module.exports = __webpack_public_path__ + "img/02.f67a923d.png";